export default "__VITE_ASSET__7a6d99d8__"